import TicketSelectorV2 from './TicketSelectorV2.jsx';

export default TicketSelectorV2;
